import { useEffect, useMemo } from 'react'

import { HIRING_SCREENS_ENUM } from 'integration/resources/auth'
import { useBreakpointValue } from 'native-base'

import { HIRING_URLS, UseHiringScreen } from './HiringScreen.types'

const getUrl = (screenType: HIRING_SCREENS_ENUM) => {
  switch (screenType) {
    case HIRING_SCREENS_ENUM.WALLETS_MANAGEMENT:
      return HIRING_URLS.WALLETS_MANAGEMENT

    case HIRING_SCREENS_ENUM.GOALS:
      return HIRING_URLS.GOALS

    case HIRING_SCREENS_ENUM.DELEGATION:
      return HIRING_URLS.DELEGATION

    case HIRING_SCREENS_ENUM.MIGRATION:
      return HIRING_URLS.MIGRATION

    case HIRING_SCREENS_ENUM.MOVEMENT:
      return HIRING_URLS.MOVEMENT

    default:
      break
  }
}

export const useHiringScreen: UseHiringScreen = ({ navigation, route }) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  const screenType = Number(route.params.screenType)

  const url = useMemo(() => getUrl(screenType), [screenType])

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const iframe = document.getElementById('hiring-iframe')

      if (!iframe) {
        console.error('Iframe element not found')

        return
      }

      if (event?.data?.action === 'expandirIframe') {
        iframe.style.position = 'fixed'

        iframe.style.top = '0'

        iframe.style.left = '0'

        iframe.style.width = '100vw'

        iframe.style.height = '100vh'

        iframe.style.border = 'none'

        iframe.style.zIndex = '9999'
      } else if (event?.data?.action === 'reduzirIframe') {
        iframe.style.position = 'static'

        iframe.style.width = '100%'

        iframe.style.height = '96%'

        iframe.style.zIndex = 'auto'
      } else {
        console.warn('Unrecognized action:', event?.data?.action)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    isMobile,
    url
  }
}
